import { createAsyncAction } from 'redux-promise-middleware-actions';
import dayjs from 'dayjs';
import { addAsyncActionPostfixes } from '../utils/actionTypeCreator';
import { tneAxiosClient } from '../api/apiSettings';
import { appAreas } from '../utils/constants';
import { generalEnums } from '../utils/enums';

export const types = {
  ...addAsyncActionPostfixes({
    GET_OPTIONS_FILTERS: 'GET_OPTIONS_FILTERS'
  })
};

export const getOptionsForFilters = createAsyncAction(
  types.GET_OPTIONS_FILTERS,
  (part, isApprover, date, location = '', status, claimName = '', startDate = '') => {
    switch (part) {
      case appAreas.TIMESHEETS: {
        const locationField = typeof location !== 'object' ? location : '';
        return tneAxiosClient
          .get(
            `/v1/${
              isApprover
                ? `get-approver-timesheet-filter-details${`?date=${
                    date ? dayjs(date).format(generalEnums.DATEFORMAT) : ''
                  }`}${`&Location=${locationField === 'All' ? '' : locationField || ''}`}${`&Status=${
                    status === 'All' ? '' : status || ''
                  }`}${`&StartDate=${startDate}`}${`&EndDate=${
                    startDate ? dayjs(startDate).add(6, 'day').format(generalEnums.DATEFORMAT) : ''
                  }`}`
                : `get-my-timesheet-filter-details${`?date=${
                    date ? dayjs(date).format(generalEnums.DATEFORMAT) : ''
                  }`}${`&Location=${location === 'All' ? '' : location || ''}`}${`&Status=${
                    status === 'All' ? '' : status || ''
                  }`}${`&StartDate=${startDate}`}${`&EndDate=${
                    startDate ? dayjs(startDate).add(6, 'day').format(generalEnums.DATEFORMAT) : ''
                  }`}`
            }`
          )
          .then((res) => res.data.Data);
      }
      case appAreas.EXPENSES: {
        return tneAxiosClient
          .get(
            `/v1/${
              isApprover
                ? `get-approver-expense-filter-details${`?date=${
                    date ? dayjs(date).format(generalEnums.DATEFORMAT) : ''
                  }`}${`&ClaimName=${claimName === 'All' ? '' : claimName || ''}`}${`&Status=${
                    status === 'All' ? '' : status || ''
                  }`}`
                : `get-my-expense-filter-details${`?date=${
                    date ? dayjs(date).format(generalEnums.DATEFORMAT) : ''
                  }`}${`&ClaimName=${claimName === 'All' ? '' : claimName || ''}`}${`&Status=${
                    status === 'All' ? '' : status || ''
                  }`}`
            }`
          )
          .then((res) => res.data.Data);
      }
      default:
        return [];
    }
  }
);
